import { render, staticRenderFns } from "./IncomingMessageWidget.vue?vue&type=template&id=516f1160&scoped=true&"
import script from "./IncomingMessageWidget.vue?vue&type=script&lang=js&"
export * from "./IncomingMessageWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "516f1160",
  null
  
)

export default component.exports